export default __webpack_public_path__ + "static/media/vampire.5ecf75c1.png";